export const STORED_COMPOSITION_LABEL = 'GeoComposition'
